import { WorkbenchConfiguration } from 'src/app/models/configurators-2d/applications/workbench/configurations/configuration';
import { WorkbenchService } from 'src/app/services/configurators-2d/applications/workbench.service';
import { ConfiguratorItem } from '../configurator-item';

export abstract class WorkbenchConfiguratorItem extends ConfiguratorItem<WorkbenchConfiguration, WorkbenchService> {
  constructor(workbenchService: WorkbenchService) {
    super(workbenchService);
  }
}
